import React from "react";
import { Box, Typography, styled } from "@mui/material";
import { GREEN } from "../../styles/mui-theme";
import { ItemType } from "../../types/types";
import { calculateDiscountedPrice, formatCOP } from "../../utils/format";
import { DiscountBadge, OriginalPrice } from "../../pages/shared/styledComponents";
import { AVAILABILITY_TEXTS } from "../../pages/shared/constants";

const QuotePrice = styled(Typography)(({ theme }) => ({
  color: theme.palette.purchase.quote,
}));

interface PublicItemProps {
  item: ItemType;
}

const Price: React.FC<PublicItemProps> = ({ item }) => {
  // A third of the live catalog has no price. Returning `null` left a hole where the price goes,
  // which reads as a page that failed to load rather than as a product we have to quote
  // (docs/ordering-flow/README.md §3.3).
  if (!item.price) {
    return (
      <QuotePrice variant="h5" fontWeight="bold">
        {AVAILABILITY_TEXTS.quotePrice}
      </QuotePrice>
    );
  }

  if (item.discount > 0) {
    return (
      <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
        <OriginalPrice variant="h6">{formatCOP(item.price)}</OriginalPrice>
        <Typography variant="h5" fontWeight="bold" color="success.main">
          {formatCOP(calculateDiscountedPrice(item.price, item.discount))}
        </Typography>
        <DiscountBadge label={`-${item.discount}%`} size="small" />
      </Box>
    );
  }

  return (
    <Typography variant="h5" fontWeight="bold" color={GREEN}>
      {formatCOP(item.price)}
    </Typography>
  );
};

export default Price;
